import { indexFingerCoverTipOut } from '../../../../glove/rightThrow/back/fingerCoverOrPad/indexFingerCoverTipOut'
import { fingerCoverTipOut } from './fingerCoverTipOut'
import { indexFingerCover } from './indexFingerCover'
import { indexFingerPad } from './indexFingerPad'

const getFingerGuardPositionCoordinate = (position: string) => {
  switch (position) {
    case 'onIndex':
      return { x: 30, y: -30, numerator: 3 }
    case 'onIndexLeft':
      return { x: -100, y: 90, numerator: -10 }
    case 'onFingerCrotch':
      return { x: -125, y: 100, numerator: -12 }
    case 'onMiddleRight':
      return { x: -160, y: 115, numerator: -15 }
    case 'onMiddle':
      return { x: -80, y: 35, numerator: -5 }
    default:
      return { x: 0, y: 0, numerator: 0 }
  }
}

export const fingerGuardDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerGuardType: string,
  indexCoverColor: string,
  stitchColor: string,
  fingerGuardPosition: string
): void => {
  const { x, y, numerator } = getFingerGuardPositionCoordinate(fingerGuardPosition)
  const isCover = fingerGuardType === 'indexCover'

  if (isCover) {
    switch (fingerGuardPosition) {
      case 'onIndex':
      case 'onMiddle':
        indexFingerCover(ctx, indexCoverColor, stitchColor, x, y, numerator)
        break
      case 'onIndexLeft':
      case 'onFingerCrotch':
      case 'onMiddleRight':
        fingerCoverTipOut(ctx, indexCoverColor, stitchColor, x, y, numerator)
        break
      default:
        indexFingerCover(ctx, indexCoverColor, stitchColor, x, y, numerator)
        break
    }
  }
}
